/**
 * A tab opened before a deploy still runs the old build, whose lazy chunks the deploy removed:
 * hosting answers the missing file with index.html and the router fails with a ChunkLoadError
 * (the page sat on "Signing in..." until a hard refresh, 28 Oct). Reloading picks up the new
 * build; the timestamp guard keeps a genuinely missing file from reloading the page in a loop.
 */
export const STALE_BUILD_RELOAD_KEY = 'ng-stale-build-reload-at';
const RELOAD_GUARD_MS = 60_000;

export function isChunkLoadError(err: unknown): boolean {
    if (!(err instanceof Error)) return false;
    return (
        err.name === 'ChunkLoadError' ||
        /Loading chunk .+ failed/.test(err.message) ||
        /Failed to fetch dynamically imported module/.test(err.message)
    );
}

export function shouldReloadForStaleBuild(
    err: unknown,
    storage: Pick<Storage, 'getItem' | 'setItem'>,
    now: number
): boolean {
    if (!isChunkLoadError(err)) return false;
    try {
        const last = Number(storage.getItem(STALE_BUILD_RELOAD_KEY) || 0);
        if (now - last < RELOAD_GUARD_MS) return false;
        storage.setItem(STALE_BUILD_RELOAD_KEY, String(now));
        return true;
    } catch {
        return false;
    }
}
